import React from 'react';
import DOMPurify from 'dompurify';
import renderHTML from 'react-render-html';

export default ({ stringHtml }) => (
  <>{renderHTML(DOMPurify.sanitize(stringHtml))}</>
);
